import { create } from "zustand";

export type PendingNqlMessage =
  | { kind: "text"; searchId: string; message: string }
  | { kind: "similar_profile_ids"; searchId: string; message: string }
  | null;

interface PendingNqlMessageState {
  pending: PendingNqlMessage;
  set: (p: PendingNqlMessage) => void;
  /** Reads and clears the pending message atomically. */
  consume: () => PendingNqlMessage;
}

/**
 * Carries an initial prompt across the hero -> detail-page navigation
 * for a newly-created search.
 *
 * Two variants:
 *   - `kind: "text"` — recruiter-typed NQL or JD-derived message. Shows
 *     as a normal user bubble in the chat.
 *   - `kind: "similar_profile_ids"` — server-composed seed instruction for
 *     the find-similar flow. The chat endpoint persists this with empty
 *     ui_parts so the bubble is hidden — the agent's first response is
 *     the first visible turn.
 *
 * Deliberately NOT persisted: if the user hard-refreshes before the agent
 * stream starts, the pending message is lost.
 */
export const usePendingNqlMessage = create<PendingNqlMessageState>(
  (set, get) => ({
    pending: null,
    set: (pending) => set({ pending }),
    consume: () => {
      const current = get().pending;
      if (current !== null) set({ pending: null });
      return current;
    },
  }),
);
